import { Box, CircularProgress } from '@mui/material';

/**
 * 页面加载骨架
 * 在懒加载页面或数据加载时展示
 */
export function PageLoading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      width="100%"
    >
      <CircularProgress />
    </Box>
  );
}
